import React, { useState } from 'react';
import Card from 'components/card/Card';
import { Tab, Tabs, TabList, TabPanels, TabPanel } from '@chakra-ui/react';

import About from './components/about';
import PermissionGroupAssined from './components/permissionGroupAssigned/table';

export default function AdminUser() {
  return (
    <>
      <Card
        direction='column'
        w='100%'
        px='20px'
        mt={{ base: '140px', md: '120px' }}
        overflowX={{ sm: 'scroll', lg: 'hidden' }}>
        <Tabs
          isFitted
          variant='enclosed'>
          <TabList mb='1em'>
            <Tab>Admin Details</Tab>
            <Tab>Permission Groups Assigned</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <About withId={true} />
            </TabPanel>
            <TabPanel>
              <PermissionGroupAssined withId={true} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Card>
    </>
  );
}
